import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import getCessionRequestingPlatformCode from '../helpers/get-default-requesting-platform-code';
import GET_ENVIRONMENT_FUND from '../graphql/queries/get-environment-fund';

const usePlatformAssigneeInfo = () => {
  const requestingPlatformCode = getCessionRequestingPlatformCode();
  const { data, loading, error } = useQuery(GET_ENVIRONMENT_FUND, {
    ...(requestingPlatformCode != null && {
      variables: { requestingPlatformCode },
    }),
  });

  const platformAssigneeInfo = useMemo(() => {
    const environmentFund = data?.getEnvironmentFund;
    if (!environmentFund) return [];

    const {
      email,
      address,
      masterEntity,
    } = environmentFund;

    return [
      `RUT: ${masterEntity?.displayNationalIdentifier || ''}`,
      `Razón social: ${masterEntity?.name || ''}`,
      `Dirección: ${address || ''}`,
      `Email: ${email || ''}`,
    ];
  }, [data]);

  return { platformAssigneeInfo, loading, error };
};

export default usePlatformAssigneeInfo;
